import CalendarSlide from '../CalendarSlide'

export default function BookCallSlide (props) {
  return (
    <CalendarSlide
      id='book-call-slide'
      stageName='Finding your place at Aragon'
      title={"We'd love to chat!"}
      description={
        'Please use this calendar to book your new joiners call. This call will be with one of our core contributors and is meant to familiarize you with the DAO, the Aragon Product Suite, and any other information you may need so we can all be successful.'
      }
      calendalyUrl={'https://calendly.com/catapultlabs'}
      thumb={'imgs/products/client.png'}
      cardTitle={'Aragon New Joiners call'}
      cardSubtitle={'Just a short welcome call'}
      showProgress={false}
      {...props}
    />
  )
}
